<template>
    <!-- 底部导航容器 -->
    <div class="bottom-nav">
        <!-- 媒体选项 -->
        <div
            class="nav-item"
            :class="{ active: $route.path === '/screenControl' }"
            @click="goTo('/screenControl')"
        >
            <i class="el-icon-data-analysis nav-icon"></i>
            <span class="nav-text">媒体</span>
        </div>

        <!-- 数据图表图标（推荐） -->
        <div
            class="nav-item"
            :class="{ active: $route.path === '/monitor' }"
            @click="goTo('/monitor')"
        >
            <i class="el-icon-s-data nav-icon"></i>
            <span class="nav-text">监测</span>
        </div>

        <!-- 巡查选项 -->
        <div
            class="nav-item"
            :class="{ active: $route.path === '/inspection' }"
            @click="goTo('/inspection')"
        >
            <i class="el-icon-document-checked nav-icon"></i>
            <span class="nav-text">巡查</span>
        </div>

        <!-- 我的选项 -->
        <div
            class="nav-item"
            :class="{ active: $route.path === '/mine' }"
            @click="goTo('/mine')"
        >
            <i class="el-icon-user nav-icon"></i>
            <span class="nav-text">我的</span>
        </div>


    </div>
</template>

<script>
export default {
    name: 'BottomNav',
    methods: {
        // 路由跳转方法
        goTo(path) {
            // 如果点击的是当前页面，则刷新
            if (this.$route.path === path) {
                window.location.reload();
            } else {
                this.$router.push(path);
            }
        }
    }
};
</script>

<style scoped>
/* 底部导航整体样式 - 核心美化 */
.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 56px; /* 加高一点更舒适 */
    display: flex;
    align-items: center;
    justify-content: space-between; /* 左右分布 */
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%); /* 渐变背景 */
    border-top: 1px solid #e9ecef;
    padding: 0 24px; /* 适配 4 项导航 */
    box-shadow: 0 -3px 15px rgba(0, 0, 0, 0.03); /* 更柔和的阴影 */
    z-index: 999;
    border-radius: 16px 16px 0 0; /* 顶部圆角 */
    margin: 0 8px 0 8px; /* 左右留边，更精致 */
}

/* 单个导航项 - 增加动效 */
.nav-item {
    flex: 0 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column; /* 图标在上，文字在下 */
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #6c757d; /* 默认灰色 */
    font-size: 14px; /* 文字小一点更精致 */
    transition: all 0.2s ease; /* 过渡动画 */
    padding: 0 12px; /* 点击区域更大 */
    position: relative;
}

/* 选中态样式 - 高亮 */
.nav-item.active {
    color: #409eff; /* Element UI 主色调 */
    font-weight: 500;
}

/* 鼠标hover/点击动效 */
.nav-item:hover {
    color: #3399ff;
    transform: translateY(-1px); /* 轻微上移 */
}

/* 图标样式 */
.nav-icon {
    text-decoration-line: none;
    font-size: 20px; /* 图标大小 */
    margin-bottom: 4px; /* 图标和文字间距 */
}

/* 文字样式 */
.nav-text {
    display: block;
    line-height: 1;
}

/* 适配页面内容，避免被遮挡 */
body {
    padding-bottom: 64px; /* 比导航栏高度多一点，留边距 */
}

/* 移动端适配 */
@media (max-width: 768px) {
    .bottom-nav {
        padding: 0 12px;
        margin: 0 4px 0 4px;
        height: 52px;
    }
    .nav-icon {
        font-size: 18px;
    }
    .nav-text {
        font-size: 13px;
    }
}
</style>
